<template>
    <el-form :model="form" ref="numberValidateForm" label-width="100px" class="demo-ruleForm">
    <el-form-item
      label="年龄"
      prop="age"
      :rules="[
          { type: 'number', message: '年龄必须为数字值'}
        ]"
    >
      <el-input type="age" v-model.number="form.age" autocomplete="off"></el-input>
    </el-form-item>
    </el-form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        age: ''
      }
    };
  }
}
</script>



// WEBPACK FOOTER //
// src/components/B.vue